import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { AuthProvider } from './context/AuthContext';
import './index.css';

// Prod-only favicon: local dev keeps the plain globe so dev tabs are distinguishable.
// import.meta.env.PROD is true for `vite build` (deployed), false for `vite dev`.
if (import.meta.env.PROD) {
  const link =
    (document.querySelector("link[rel='icon']") as HTMLLinkElement | null) ??
    document.head.appendChild(
      Object.assign(document.createElement('link'), { rel: 'icon' })
    );
  link.type = 'image/png';
  link.href = '/sequesto-icon.png';
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5,
      retry: 1,
    },
  },
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <AuthProvider>
          <App />
        </AuthProvider>
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>
);
